/**
 * SilkTale 品牌 - Member 页面配置
 */
import { memberCommonConfig } from './common'
import type { MemberPageConfig } from './types'

export const theme = {
  // 头像边框色
  avatarBorder: '#FFF7ED',
  // 按钮背景色
  btnPrimaryBg: '#FFF7ED',
  // Top Up 按钮背景色
  topUpBtnBg: '#FD9540',
  // VIP 背景图 URL
  vipSubscribeBg: 'url(/images/silktale/member_subscribe_bg.webp)',
} as const

export const resources = {
  // 页面背景图
  memberBg: '/images/silktale/member-bg.webp',
  // 用户背景图
  userBg: '/images/silktale/user-bg.webp',
  // 用户默认头像
  userDefaultAvatar: '/images/silktale/user-default.png',
  // VIP 图标
  memberVip: '/images/silktale/member-vip.png',
  // VIP 折扣图标
  memberVipDiscount: '/images/silktale/member-vip-discount.png',
} as const

export const memberConfig: MemberPageConfig = {
  theme,
  resources,
  texts: memberCommonConfig.texts,
}
